import React, { useState } from "react";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
  
function AuthPage({ onLoginSuccess }) {
  const [showLogin, setShowLogin] = useState(true);

  return (
    <div>
      {showLogin ? (
        <>
          <LoginForm onLoginSuccess={onLoginSuccess} />
          <p onClick={() => setShowLogin(false)}>
          </p>
        </>
      ) : (
        <>
          <RegisterForm onRegisterSuccess={() => setShowLogin(true)} />
          <p onClick={() => setShowLogin(true)}>
          </p>
        </>
      )}
    </div>
  );
}

export default AuthPage;
